import type { Language } from '@offer-catalog/services/i18n'
import type { CountryItem, DdfsCountry } from '@/types/countries'
import { getCountryName, sortCountriesByName } from '@/utils/countries'
import { fetchAllDdfsResource, fetchDdfsCollection } from './ddfs'

export async function fetchCountriesByCodes(codes: string[], currentLanguage: Language): Promise<CountryItem[]> {
  if (codes.length === 0)
    return []

  const response = await fetchDdfsCollection<DdfsCountry>('countries', {
    'alpha2[]': codes,
    'active_decathlon': 'true',
  }, currentLanguage)

  const countriesById = new Map<number, CountryItem>()
  appendSelectableCountries(countriesById, response.items, currentLanguage)
  return sortCountriesByName([...countriesById.values()])
}

function isSelectableCountry(country: DdfsCountry) {
  return Boolean(country.alpha2)
}

function normalizeCountry(country: DdfsCountry, language: Language): CountryItem {
  const code = country.alpha2.toUpperCase()

  return {
    id: country.id,
    code,
    name: country.name?.trim() || getCountryName(code, language) || code,
  }
}

function appendSelectableCountries(
  countriesById: Map<number, CountryItem>,
  countries: DdfsCountry[],
  language: Language,
) {
  countries
    .filter(isSelectableCountry)
    .forEach((country) => {
      const normalizedCountry = normalizeCountry(country, language)
      countriesById.set(normalizedCountry.id, normalizedCountry)
    })
}

export async function fetchAllCountries(currentLanguage: Language): Promise<CountryItem[]> {
  const countriesById = new Map<number, CountryItem>()
  const countries = await fetchAllDdfsResource<DdfsCountry>('countries', currentLanguage, {
    active_decathlon: 'true',
  })

  appendSelectableCountries(countriesById, countries, currentLanguage)

  return sortCountriesByName([...countriesById.values()])
}
